import {connect} from 'react-redux';
import * as SalesforceDataStepActions from '../../actions/mx/SalesforceDataStepActions';
import {State} from '../../../../types/mx/reducers';
import {
    SalesforceOpportunityCancelStateProps, SalesforceOpportunityCancelDispatchProps,
} from '../../types/mx/containers';
import * as ModalActions from '../../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import SalesforceOpportunityCancelConfirmView from '../../components/views/mx/SalesforceOpportunityCancelConfirmView';
const mapStateToProps = (state: State): SalesforceOpportunityCancelStateProps => {
    return {
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): SalesforceOpportunityCancelDispatchProps => {
    return {
        onPressCancelConfirm: () => {
            dispatch(SalesforceDataStepActions.SALESFORCE_CANCEL_ACTION.action());
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const SalesforceOpportunityCancelConfirmContainer = connect(
    mapStateToProps, mapDispatchToProps,
)(SalesforceOpportunityCancelConfirmView);

export default SalesforceOpportunityCancelConfirmContainer;
